import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectSelectedComponent, updateComponent } from '../../../redux/editorSlice';
import { SkinSelector } from '../CommonProperties';

const RecommendedUsersProperties = () => {
  const selectedComponent = useSelector(selectSelectedComponent);
  const dispatch = useDispatch();
  
  // 컴포넌트 속성 변경 핸들러
  const handleComponentPropsChange = (property, value) => {
    const existingProps = JSON.parse(JSON.stringify(selectedComponent.componentProps || {}));
    existingProps[property] = value;
    
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        componentProps: existingProps
      }
    }));
  };

  return (
    <>
      {/* 스킨 선택 */}
      <SkinSelector
        selectedComponent={selectedComponent}
        onSkinChange={(skinId) => handleComponentPropsChange('skin', skinId)}
      />
      
      {/* 기본 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          기본 설정
        </div>
        
        <div className="property-control">
          <label>제목</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.title || '피추천인 목록'} 
            onChange={(e) => handleComponentPropsChange('title', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>페이지당 항목 수</label>
          <input 
            type="number" 
            min="5" 
            max="50" 
            value={selectedComponent.componentProps?.itemsPerPage || 10} 
            onChange={(e) => handleComponentPropsChange('itemsPerPage', parseInt(e.target.value))}
          />
        </div>
      </div>
      
      {/* 표시 옵션 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" stroke="currentColor" strokeWidth="2"/>
            <path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" stroke="currentColor" strokeWidth="2"/>
          </svg>
          표시 옵션
        </div>
        
        <div className="property-control">
          <label>
            <input 
              type="checkbox" 
              checked={selectedComponent.componentProps?.showTotalCount !== false}
              onChange={(e) => handleComponentPropsChange('showTotalCount', e.target.checked)}
            />
            총 개수 표시
          </label>
        </div>
        
        <div className="property-control">
          <label>
            <input 
              type="checkbox" 
              checked={selectedComponent.componentProps?.showUserIds !== false}
              onChange={(e) => handleComponentPropsChange('showUserIds', e.target.checked)}
            />
            사용자 ID 표시
          </label>
        </div>
        
        <div className="property-control">
          <label>
            <input 
              type="checkbox" 
              checked={selectedComponent.componentProps?.showUserNames !== false}
              onChange={(e) => handleComponentPropsChange('showUserNames', e.target.checked)}
            />
            사용자 이름 표시
          </label>
        </div>
        
        <div className="property-control">
          <label>
            <input 
              type="checkbox" 
              checked={selectedComponent.componentProps?.showCreatedDate !== false}
              onChange={(e) => handleComponentPropsChange('showCreatedDate', e.target.checked)}
            />
            가입일 표시
          </label>
        </div>
        
        <div className="property-control">
          <label>
            <input 
              type="checkbox" 
              checked={selectedComponent.componentProps?.showPagination !== false}
              onChange={(e) => handleComponentPropsChange('showPagination', e.target.checked)}
            />
            페이지네이션 표시
          </label>
        </div>
        
        <div className="property-control">
          <label>
            <input 
              type="checkbox" 
              checked={selectedComponent.componentProps?.showAvatars || false}
              onChange={(e) => handleComponentPropsChange('showAvatars', e.target.checked)}
            />
            아바타 표시
          </label>
        </div>
        
        <div className="property-control">
          <label>
            <input 
              type="checkbox" 
              checked={selectedComponent.componentProps?.compactMode || false}
              onChange={(e) => handleComponentPropsChange('compactMode', e.target.checked)}
            />
            컴팩트 모드
          </label>
        </div>
      </div>
      
      {/* 레이아웃 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
            <path d="M9 9h6M9 12h6M9 15h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          레이아웃 설정
        </div>
        
        <div className="property-control">
          <label>레이아웃 스타일</label>
          <select 
            value={selectedComponent.componentProps?.listLayout || 'card'}
            onChange={(e) => handleComponentPropsChange('listLayout', e.target.value)}
          >
            <option value="card">카드</option>
            <option value="list">리스트</option>
            <option value="table">테이블</option>
          </select>
        </div>
      </div>
      
      {/* 색상 테마 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2v20M2 12h20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
          </svg>
          색상 테마
        </div>
        
        <div className="property-control">
          <label>배경 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.backgroundColor || "#ffffff"}
            onChange={(e) => handleComponentPropsChange('backgroundColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>테두리 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.borderColor || "#e0e0e0"}
            onChange={(e) => handleComponentPropsChange('borderColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>텍스트 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.textColor || "#333333"}
            onChange={(e) => handleComponentPropsChange('textColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>제목 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.titleColor || "#2c3e50"}
            onChange={(e) => handleComponentPropsChange('titleColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>주요 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.primaryColor || "#3f51b5"}
            onChange={(e) => handleComponentPropsChange('primaryColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>보조 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.secondaryColor || "#6c757d"}
            onChange={(e) => handleComponentPropsChange('secondaryColor', e.target.value)}
          />
        </div>
      </div>
      
      {/* 아이템 스타일 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="2"/>
          </svg>
          아이템 스타일
        </div>
        
        <div className="property-control">
          <label>아이템 배경 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.itemBackgroundColor || "#ffffff"}
            onChange={(e) => handleComponentPropsChange('itemBackgroundColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>아이템 테두리 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.itemBorderColor || "#e0e0e0"}
            onChange={(e) => handleComponentPropsChange('itemBorderColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>아이템 호버 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.itemHoverColor || "#f8f9fa"}
            onChange={(e) => handleComponentPropsChange('itemHoverColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>아이템 모서리 반경</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.itemBorderRadius || "8px"}
            onChange={(e) => handleComponentPropsChange('itemBorderRadius', e.target.value)}
            placeholder="예: 8px"
          />
        </div>
        
        <div className="property-control">
          <label>아이템 패딩</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.itemPadding || "16px"}
            onChange={(e) => handleComponentPropsChange('itemPadding', e.target.value)}
            placeholder="예: 16px"
          />
        </div>
        
        <div className="property-control">
          <label>아이템 마진</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.itemMargin || "8px"}
            onChange={(e) => handleComponentPropsChange('itemMargin', e.target.value)}
            placeholder="예: 8px"
          />
        </div>
      </div>
      
      {/* 타이틀 스타일 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M18 2l4 4-10 10H8v-4L18 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          타이틀 스타일
        </div>
        
        <div className="property-control">
          <label>제목 폰트 크기</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.titleFontSize || "24px"}
            onChange={(e) => handleComponentPropsChange('titleFontSize', e.target.value)}
            placeholder="예: 24px"
          />
        </div>
        
        <div className="property-control">
          <label>제목 폰트 굵기</label>
          <select 
            value={selectedComponent.componentProps?.titleFontWeight || 'bold'}
            onChange={(e) => handleComponentPropsChange('titleFontWeight', e.target.value)}
          >
            <option value="normal">보통</option>
            <option value="bold">굵게</option>
            <option value="600">600</option>
            <option value="700">700</option>
            <option value="800">800</option>
          </select>
        </div>
        
        <div className="property-control">
          <label>제목 아래 여백</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.titleMarginBottom || "20px"}
            onChange={(e) => handleComponentPropsChange('titleMarginBottom', e.target.value)}
            placeholder="예: 20px"
          />
        </div>
      </div>
      
      {/* 텍스트 스타일 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <polyline points="14,2 14,8 20,8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          텍스트 스타일
        </div>
        
        <div className="property-control">
          <label>이름 폰트 크기</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.nameFontSize || "16px"}
            onChange={(e) => handleComponentPropsChange('nameFontSize', e.target.value)}
            placeholder="예: 16px"
          />
        </div>
        
        <div className="property-control">
          <label>이름 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.nameColor || "#2c3e50"}
            onChange={(e) => handleComponentPropsChange('nameColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>날짜 폰트 크기</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.dateFontSize || "14px"}
            onChange={(e) => handleComponentPropsChange('dateFontSize', e.target.value)}
            placeholder="예: 14px"
          />
        </div>
        
        <div className="property-control">
          <label>날짜 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.dateColor || "#6c757d"}
            onChange={(e) => handleComponentPropsChange('dateColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>ID 폰트 크기</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.idFontSize || "14px"}
            onChange={(e) => handleComponentPropsChange('idFontSize', e.target.value)}
            placeholder="예: 14px"
          />
        </div>
        
        <div className="property-control">
          <label>ID 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.idColor || "#495057"}
            onChange={(e) => handleComponentPropsChange('idColor', e.target.value)}
          />
        </div>
      </div>
      
      {/* 페이지네이션 스타일 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="2"/>
            <line x1="7" y1="8" x2="7" y2="16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <line x1="17" y1="8" x2="17" y2="16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          페이지네이션 스타일
        </div>
        
        <div className="property-control">
          <label>버튼 배경 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.paginationButtonColor || "#ffffff"}
            onChange={(e) => handleComponentPropsChange('paginationButtonColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>버튼 테두리 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.paginationButtonBorderColor || "#dee2e6"}
            onChange={(e) => handleComponentPropsChange('paginationButtonBorderColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>활성 버튼 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.paginationActiveColor || "#3f51b5"}
            onChange={(e) => handleComponentPropsChange('paginationActiveColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>활성 버튼 텍스트 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.paginationActiveTextColor || "#ffffff"}
            onChange={(e) => handleComponentPropsChange('paginationActiveTextColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>버튼 호버 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.paginationHoverColor || "#f8f9fa"}
            onChange={(e) => handleComponentPropsChange('paginationHoverColor', e.target.value)}
          />
        </div>
      </div>
      
      {/* 상태 색상 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          상태 색상
        </div>
        
        <div className="property-control">
          <label>로딩 스피너 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.loadingSpinnerColor || "#3f51b5"}
            onChange={(e) => handleComponentPropsChange('loadingSpinnerColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>오류 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.errorColor || "#dc3545"}
            onChange={(e) => handleComponentPropsChange('errorColor', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>빈 상태 색상</label>
          <input 
            type="color" 
            value={selectedComponent.componentProps?.emptyStateColor || "#6c757d"}
            onChange={(e) => handleComponentPropsChange('emptyStateColor', e.target.value)}
          />
        </div>
      </div>
      
      {/* 텍스트 설정 */}
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M18 2l4 4-10 10H8v-4L18 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          메시지 설정
        </div>
        
        <div className="property-control">
          <label>빈 데이터 메시지</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.emptyText || "데이터가 없습니다"}
            onChange={(e) => handleComponentPropsChange('emptyText', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>로딩 메시지</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.loadingText || "로딩 중..."}
            onChange={(e) => handleComponentPropsChange('loadingText', e.target.value)}
          />
        </div>
        
        <div className="property-control">
          <label>로그인 필요 메시지</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.loginRequiredText || "로그인이 필요합니다."}
            onChange={(e) => handleComponentPropsChange('loginRequiredText', e.target.value)}
          />
        </div>
      </div>

    </>
  );
};

export default RecommendedUsersProperties; 